"use client";

// TODO(DS): replace with @tb/icon when DS icon set is available
import { ArrowLeft } from "lucide-react";

import { BACK_LINK_CLASS } from "@/components/shared/step-header";
import { Button } from "@/components/ui/button";

interface BackLinkProps {
  onClick: () => void;
  children: string;
}

export function BackLink({ onClick, children }: BackLinkProps) {
  return (
    <Button type="button" variant="ghost" size="sm" onClick={onClick} className={BACK_LINK_CLASS}>
      <ArrowLeft size={14} /> {children}
    </Button>
  );
}
